import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyle from './styles/GlobalStyles';
import AppProvider from './hooks';
import Routes from './routes';
import Sidebar from './components/SideBar';

const App: React.FC = () => {
  return (
    <Router>
      <AppProvider>
        <Sidebar>
          <Routes />
        </Sidebar>
      </AppProvider>
      <GlobalStyle />
    </Router>
  );
};

export default App;
